import React, { useState } from 'react';
import Flex, { FlexItem } from 'styled-flex-component';

import { useTrackedState } from '../lib/state';

import SubLayout from '../components/SubLayout';
import { P } from '../components/common/P.style';
import { Img } from '../components/common/Img.style';
import Link from '../components/Link';
import { H2, H2Background, H3, H4 } from '../components/common/H.style';
import { UL } from '../components/common/UL.style';
import { LI } from '../components/common/LI.style';
import Anchor from '../components/Anchor';

import WeeklySchedule from '../components/WeeklySchedule';
import ClosedDayLabel from '../components/ClosedDayLabel';
import AccessInfoArea from '../components/AccessInfoArea';
import Modal from '../components/Modal';

import us1lg from '../assets/img/us-1-lg.png';

const About = () => {
  const { size } = useTrackedState();
  const [open, setOpen] = useState(false);
  return (
    <SubLayout topTitle="求人情報">
      <div>
        ヒラハタクリニックでは、現在以下の職種の募集を行っております。
        <br />
        求人に関するお問い合わせやご応募は{' '}
        <a href="mailto:keiri＠hirahata-clinic.or.jp">keiri@hirahata-clinic.or.jp</a>{' '}
        へお願いいたします。
        <Anchor id="jimu"></Anchor>
        {/* 
        <H3>非常勤医師（呼吸器内科）</H3>
        <div
          css={`
            margin: 1em;
          `}
          style="display:none"
        >
          内科外来　コロナ後遺症・オンライン診療の対応をお願いします。
          <br />
          健康診断　問診、聴打診、胸部読影（ダブルチェック）、結果チェック等。
          <br />
          <h4>【給与】</h4>
          <ul>
            <li>日給80,000円　交通費別途支給（車通勤不可）</li>
          </ul>
          <h4>【勤務時間・曜日】</h4>
          <ul>
            <li>9:00～18:00（休憩1時間）</li>
            <li>火曜日、金曜日（祝日は休み）</li>
          </ul>
         
          <h4>【待遇・福利厚生】</h4>
          <ul>
            <li>ＰＣ貸与</li>
            <li>レクチャー動画や資料をご用意しています。</li>
            <li>ご希望であれば見学も大歓迎。</li>
            <li>質問も随時ＯＫ</li>
          </ul>

          <h4>【応募条件・資格】</h4>
          <ul>
            <li>インターネット回線必須（SoftBank Airなどの無線回線は不可）</li>
          </ul> 
          詳細については　
          <a href="mailto:keiri＠hirahata-clinic.or.jp">keiri@hirahata-clinic.or.jp</a>
          　までお問い合わせください。
        </div>
      */}
        {/* <H3>看護師、准看護師(パートタイム)</H3>
        <div>

          <h4>【業務内容】</h4>
          <ul>
            <li>健康診断業務</li>
            <li>心電図、採血、血圧、眼底、脈波</li>
            <li>外来、点滴、内視鏡介助</li>
          </ul>

          <h4>【勤務時間・曜日】</h4>
          <ul>
            <li>（早番）8:45～17:45</li>
            <li>（遅番）12:00～21:00</li>
            <li>休憩60分</li>
            <li>月～土　週4日～5日シフト制</li>
            <li>勤務開始時間は応相談</li>
            <li>早番のみの勤務も歓迎します</li>
          </ul>

          <h4>【給与】</h4>
          <ul>
            <li>正看護師：時給2,300円　准看護師：時給2,200円</li>
          </ul>
          ※残業代別途支給<br />

          <h4>【休日休暇】</h4>
          <ul>
            <li>日、祝日、夏季休暇、年末年始休暇</li>
          </ul>

          <h4>【待遇・福利厚生】</h4>
          <ul>
            <li>交通費支給1,000円迄/日</li>
            <li>制服貸与</li>
            <li>社会保険完備(法令遵守)</li>
            <li>有給</li>
          </ul>

          <h4>【応募条件・資格】</h4>
          <ul>
            <li>看證師免許・准看護師免許をお持ちの方</li>
            <li>看護師経験1年以上ある方</li>
            <li>雇用契約期間2023年10月1日～2025年3月31日（契約更新の可能性あり）</li>
          </ul>
          詳細については　<a href="mailto:keiri＠hirahata-clinic.or.jp">keiri@hirahata-clinic.or.jp</a>　までお問い合わせください。
        </div> */}
        {/* 
        <H3>看護師、准看護師(夜間パートタイム)</H3>
        <div>
          <h4>【業務内容】</h4>
          <ul>
            <li>健康診断業務</li>
            <li>心電図、採血、血圧、眼底、脈波</li>
            <li>外来、点滴</li>
          </ul>

          <h4>【勤務時間・曜日】</h4>
          <ul>
            <li>月・火・水・金　週2日～4日（17:30～20:30）</li>
          </ul>

          <h4>【給与】</h4>
          <ul>
            <li>正看護師：時給2,300円　准看護師：時給2,200円</li>
          </ul>
          ※残業代別途支給<br />

          <h4>【待遇・福利厚生】</h4>
          <ul>
            <li>交通費支給1,000円迄/日</li>
            <li>制服貸与</li>
          </ul>

          <h4>【応募条件・資格】</h4>
          <ul>
            <li>看證師免許・准看護師免許をお持ちの方</li>
            <li>看護師経験1年以上ある方</li>
            <li>雇用契約期間2023年11月1日～2023年12月27日</li>
          </ul>
          詳細については　<a href="mailto:keiri＠hirahata-clinic.or.jp">keiri@hirahata-clinic.or.jp</a>　までお問い合わせください。
        </div> */}
        <H3>看護師、准看護師(フルタイム)</H3>
        <div>
          <h4>【業務内容】</h4>
          <ul>
            <li>健康診断業務・点滴・外来業務・内視鏡介助など ※内視鏡介助は未経験可</li>
          </ul>
          <h4>【勤務時間・曜日】</h4>
          <ol>
            <li>08時45分 〜 17時45分</li>
            <li>12時00分 〜 21時00分</li>
          </ol>
          1、2のシフト制 <br />
          木曜・日曜・祝日は１のシフトのみ
          <br />
          ※休憩時間60分 <br />
          <h4>【給与】</h4>
          <ul>
            <li>基本給　300,000円～</li>
          </ul>
          ※残業代別途支給
          <br />
          <h4>【休日休暇】</h4>
          <ul>
            <li>週休2日制</li>
            <li>夏季休暇、年末年始休暇</li>
          </ul>
          <h4>【待遇・福利厚生】</h4>
          <ul>
            <li>昇給あり</li>
            <li>賞与あり(年2回)</li>
            <li>交通費支給（上限有）</li>
            <li>制服貸与</li>
            <li>社会保険完備(法令遵守)</li>
            <li>有給制度有</li>
          </ul>
          <h4>【応募条件・資格】</h4>
          <ul>
            <li>看護師・准看護師</li>
            <li>看護師経験が１年以上ある方（内視鏡介助の経験は不問）</li>
            <li>日曜・祝日勤務可能な方</li>
          </ul>
          詳細については　
          <a href="mailto:keiri＠hirahata-clinic.or.jp">keiri@hirahata-clinic.or.jp</a>
          　までお問い合わせください。
        </div>
        {/* <H3>鍼灸師(パートタイム)</H3>
        <div>
          <h4>【業務内容】</h4>
          外来患者様への問診、書類作成、鍼治療希望者への鍼治療<br />
          問診力が養われ、ご自身の鍼灸治療にもお役立ていただけます。<br />
          ※鍼治療は希望者がいない日もあります。<br />
          <h4>【勤務時間・曜日】</h4>
          <ul>
            <li>月・火・水・金　16:00～20:00（祝日はお休みになります。） </li>
            <li>残業できる方歓迎</li>
          </ul>
          <h4>【給与】</h4>
          <ul>
            <li>時給1,600円</li>
          </ul>
          <h4>【待遇・福利厚生】</h4>
          <ul>
            <li>賞与あり(年2回)</li>
            <li>有給制度有</li>
            <li>交通費1日1,000円まで支給</li>
            <li>制服貸与</li>
          </ul>
          <h4>【応募条件・資格】</h4>
          <ul>
            <li>鍼灸師</li>
            <li>はり師及びきゅう師（ 臨床経験３年以上）</li>
            <li>PC操作に慣れている方</li>
          </ul>
          ※3ヶ月毎の更新制になります。<br />
          詳細については　<a href="mailto:keiri＠hirahata-clinic.or.jp">keiri@hirahata-clinic.or.jp</a>　までお問い合わせください。
        </div> */}
        {/* 
        <H3>医療事務（フルタイム）</H3>
        <div>
          <h4>【業務内容】</h4>
          <ul>
            <li>クリニックでの受付、電話対応、予約管理、健康診断に関する事務など</li>
          </ul>
          <h4>【勤務時間・曜日】</h4>
          <ol>
            <li>（1）8時45分 〜 17時45分</li>
            <li>（2）12時00分 〜 21時00分 </li>
          </ol>
          (1)(2)のシフト制
          <br />
          ※休憩時間60分 <br />
          【休日休暇】 <br />
          週休2日制（シフト制） <br />
          夏季休暇、年末年始休暇 <br />
          <h4>【給与】</h4>
          <ul>
            <li>基本給　250,000 円〜</li>
            <li>医療事務資格（1万円 /月）</li>
            <li>レセプト手当（最大2万円 /月）</li>
            <li>リーダー手当（最大3万円 /月）</li>
            <li>遅番勤務手当</li>
          </ul>
          ※残業代別途支給
          <br />
          ※試用期間3ヶ月（条件変更なし）
          <br />
          <h4>【待遇・福利厚生】</h4>
          <ul>
            <li>昇給あり</li>
            <li>賞与あり(年2回)</li>
            <li>交通費支給（15,000円まで/月）</li>
            <li>制服貸与</li>
            <li>社会保険完備</li>
            <li>中小企業退職金共済加入</li>
            <li>定年60歳（再雇用65歳まで）</li>
          </ul>
          <h4>【応募条件・資格】</h4>
          <ul>
            <li>年齢・学歴・資格不問</li>
            <li>医療事務経験、リーダーポジション経験のある方優遇します。</li>
            <li>医療事務未経験者の方も歓迎します。</li>
          </ul>
          詳細については　
          <a href="mailto:keiri＠hirahata-clinic.or.jp">keiri@hirahata-clinic.or.jp</a>
          　までお問い合わせください。
        </div>
        */}
        {/*
        <H3>医療事務（パートタイム）</H3>
        <div>
          <h4>【業務内容】</h4>
          <ul>
            <li>受付・電話対応・予約管理、健康診断に関する事務など</li>
            <li>ダブルワークＯＫ</li>
            <li>
              内科、健康診断、人間ドックなど、働く人の健康管理を積極的に促進するクリニックです。
            </li>
          </ul>
          <ol>
            <li>8:45～21:00</li>
            週3日以上勤務できる方。
            <br />
            1日3時間から応相談。午前中のみ勤務も歓迎。
            <br />
          </ol>
          <h4>【給与】</h4>
          <ul>
            <li>時給1,350円</li>
          </ul>
          <h4>【待遇・福利厚生】</h4>
          <ul>
            <li>賞与あり(年2回)</li>
            <li>有給制度有</li>
            <li>交通費1日1,000円まで支給</li>
            <li>制服貸与</li>
          </ul>
          <h4>【応募条件・資格】</h4>
          <ul>
            <li>年齢・学歴・資格不問</li>
            <li>未経験の方も歓迎します。</li>
          </ul>
          詳細については　
          <a href="mailto:keiri＠hirahata-clinic.or.jp">keiri@hirahata-clinic.or.jp</a>
          　までお問い合わせください。
        </div>
      */}
      </div>
    </SubLayout>
  );
};

export default About;
